<template>
  <div class="avatar-setter" :class="type">
    <h4>Аватар</h4>
    <div class="content">
      <div class="mid">
        <img @click="setPhoto()" class="c_logo_img" :src="photo" v-if="photo != null">
        <div class="logo_text">
          <p class="title">Загрузить логотип компании для отображения в личном кабинете</p>
          <p class="desc">
            Отображается на всех устройствах. Загружайте изображения в разрешении не более 1400 × 1400
            в формате JPG или PNG.  Размер файла — до 20 Мб
          </p>
        </div>
      </div>
      <div class="buttons">
        <standart-button @click="setPhoto()" text="Загрузить" icon="download" style_type="prime"></standart-button>
        <standart-button @click="savePhoto()" text="Сохранить изменения"></standart-button>
        <input @change="photoIsSet()" class="file_field" type="file">
      </div>
    </div>
  </div>
</template>

<script>

import StandartButton from "@/components/share/StandartButton";
import axios from "axios";
export default {
  name : "AvatarSetter",
  components: {StandartButton},
  props : {
    photo : String,
    type: String,
    counterpartyId: Number
  },
  data() {
    return{

    }
  },
  methods: {
    setPhoto: async function() {
      console.log("setPhoto");

      document.querySelector('.' + this.type + ' .file_field').click();
    },
    photoIsSet() {
      let fileField = document.querySelector('.' + this.type + ' .file_field');
      console.log(fileField.files[0]);

      const file = fileField.files[0];
      if(file == undefined) {return;}

      const imageURL = URL.createObjectURL(file);

      document.querySelector('.' + this.type + ' .c_logo_img').src = imageURL;
      //fileField.value = null;
      document.querySelector('.' + this.type + ' .c_logo_img').onload = () => URL.revokeObjectURL(imageURL);
    },
    savePhoto: async function() {
      console.log("savePhoto: " + this.type);

      const bodyFormData = new FormData;

      let fileField = document.querySelector('.' + this.type + ' .file_field');
      if(fileField.files[0] == undefined) {return;}

      bodyFormData.append("photo", fileField.files[0]);

      let method = window.api_url + 'main/save_photo?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei';
      if(this.type == "account") {
        method = window.api_url + 'main/save_photo?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei';
      }
      else if(this.type == "counterparty") {
        bodyFormData.append("counterparty_id", this.counterpartyId);
        method = window.api_url + 'counterparty/save_photo?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei';
      }

      try {
        let res = await axios.post(method,
             bodyFormData, {
             headers: {
                 'Content-Type': 'multipart/form-data'
             }
        });

        if (res.data.status === "fail") {
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.avatar-setter {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
}

.avatar-setter h4 {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  margin: 0px 0px 24px 0px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.mid {
  display: flex;
  gap: 14px;
  align-items: center;
}

.avatar-setter .logo_img {
  height: 130px;
  width: 130px;
  border-radius: 115px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.avatar-setter .c_logo_img {
  height: 130px;
  width: 130px;
  border-radius: 115px;
  border: 1px solid var(--Border, #EDEDED);
  cursor: pointer;
}

.logo_text {
  gap: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.logo_text p {
  margin: 0px;
}

.logo_text .title{
  color: var(--Black, #222);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.logo_text .desc{
  color: var(--Gray, #656565);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.buttons {
  display: flex;
  gap: 20px;
}

.file_field {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .avatar-setter {
    padding: 18px;
  }

  .buttons {
    flex-direction: column;
    gap: 10px;
  }

  .mid {
    align-items: start;
    flex-direction: column;
  }
}
</style>